import { render, staticRenderFns } from "./SiteRoleDetailTop.vue?vue&type=template&id=3aede7c0&"
import script from "./SiteRoleDetailTop.vue?vue&type=script&lang=js&"
export * from "./SiteRoleDetailTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports